import { inject, provideEnvironmentInitializer } from '@angular/core';

import { CosFeatureFlagsToolbarControlsSet } from '@cosmos/feature-flags-toolbar';

export function withSignalsDebugger() {
  return provideEnvironmentInitializer(() => {
    const controls = inject(CosFeatureFlagsToolbarControlsSet);
    controls.add(async () => {
      const { CosFeatureFlagsSignalsDebuggerComponent } = await import(
        './feature-flags-signals-debugger.component'
      );
      return CosFeatureFlagsSignalsDebuggerComponent;
    });
  });
}
